"use client";

import { useRouter } from "next/navigation";
import { useMemo } from "react";

import { useNavigationStart } from "~/app/_components/PageTransitionLoader";

export function useAppRouter(): ReturnType<typeof useRouter> {
  const router = useRouter();
  const startNavigation = useNavigationStart();

  return useMemo(
    () => ({
      back: router.back,
      forward: router.forward,
      refresh: router.refresh,
      prefetch: router.prefetch,
      push: (href, options) => {
        startNavigation();
        return router.push(href, options);
      },
      replace: (href, options) => {
        startNavigation();
        return router.replace(href, options);
      },
    }),
    [router, startNavigation],
  );
}
